module.exports = require('./helpers/bundle-url').getBundleURL('4zqgQ') + "logo-dark.eefe0b7f.svg";